import axios from "axios"
import utils from "../utils"

const instance = axios.create({
    baseURL: utils.baseUrl,
    headers: {
        "Content-Type": "application/json",
    },
})

instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken')
        if(token !== null){
            config.headers['Authorization'] = `Token ${token}`;
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default instance